import { Component, Input, Output, EventEmitter, HostListener, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-image-display',
  templateUrl: './product-image-display.component.html',
  styleUrls: ['./product-image-display.component.scss'],
})
export class ProductImageDisplayComponent {
  @Input() url: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url']) {
      this.url = changes['url'].currentValue;
    }
  }
} 